<div class="dropdown d-inline-block"
     [class.open]="menuItems.opened"
     (click-outside)="menuItems.opened = false"
     *ngIf="!readOnly && hasReportAccess">
  <button class="btn btn-outline"
          test-id="threePointsButton"
          type="button"
          (click)="menuItems.opened = !menuItems.opened"
          *ngIf="hasVisibleChild">
    <span class="fa fa-light fa-ellipsis-v"></span>
  </button>
  <ul #items class="dropdown-menu" style="top: 20%;">
    <li class="dropdown-item dropdown-submenu"
        *ngIf="menuItems.certificates?.length">
      <i aria-hidden="true" class="fa fa-light fa-caret-right"></i>
      {{'EMPLOYEE_MANAGE.certificates' | translate}}
      <ul class="dropdown-menu pointer">
        <li *ngFor="let certificate of menuItems.certificates | sortByTranslations:
                         triggerSortByTranslationPipe :['descriptionTransId'] | async"
            (click)="selectReportDefinition(certificate)"
            class="dropdown-item pointer">
          {{ certificate.descriptionTransId | translate }}
        </li>
      </ul>
    </li>
  </ul>
</div>

<gp-report-definition *ngIf="cliRegId && contractId && hasReportAccess"
                      [cliRegIds]="[cliRegId]"
                      [mySpaceCliRegId]="cliRegId"
                      [contractId]="contractId"
                      [hiddenValues]="hiddenValuesForReportDefinition"
                      [types]="availableReportsType"
                      [profileType]="profileType"
                      [selectedReportDefinition]="selectedReportDefinition"
                      (reportDefinitionsLoaded)="reportDefinitionsLoaded($event)"
                      (reportDefinitionListener)="reportDefinitionListener()">
</gp-report-definition>
